import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Button from "@mui/material/Button";
import InfoIcon from "@mui/icons-material/Info";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";

const statusOptions = [
  { value: "pending", label: "قيد الانتظار", color: "#FFA726" },
  { value: "processing", label: "موافقة (قيد التجهيز)", color: "#42A5F5" },
  { value: "shipped", label: "شحن (تم الشحن)", color: "#7B1FA2" },
  { value: "completed", label: "مكتمل (تم التسليم)", color: "#66BB6A" },
  { value: "cancelled", label: "ملغي", color: "#EF5350" },
];

function formatDateTime(dateTimeString) {
  if (!dateTimeString) return "";
  const [date, time] = dateTimeString.split("T");
  const timePart = time ? time.split(":").slice(0, 2).join(":") : "";
  return `${date} - ${timePart}`;
}

export default function storesOrdersTableData(
  users,
  handleEditClick,
  fetchUsers,
  setStatus,
  status,
  handleOrderDetailsClick,
  handleStatusChange,
  loadingOrderId
) {
  return {
    columns: [
      // { Header: "رقم الطلب الرئيسي", accessor: "main_order_number", align: "center" },
      { Header: "رقم الطلب", accessor: "order_number", align: "center" },
      { Header: "تفاصيل الطلب", accessor: "order_details", align: "left" },
      { Header: "تفاصيل العميل", accessor: "customer_details", align: "left" },
      { Header: "تفاصيل الدفع والشحن", accessor: "payment_details", align: "left" },
      { Header: "حالة الطلب", accessor: "products_status", align: "center" },
      { Header: "تفاصيل الطلب", accessor: "order_action", align: "center" },
      { Header: "معاينة الطلب", accessor: "order_preview", align: "center" },
    ],
    rows: users.map((user) => ({
      // main_order_number: (
      //   <MDTypography variant="caption" color="text" fontWeight="xl">
      //     {user.order_id}
      //   </MDTypography>
      // ),
      order_number: (
        <MDTypography variant="caption" color="text" fontWeight="large">
          {user.id}
        </MDTypography>
      ),
      order_details: (
        <MDBox display="flex" flexDirection="column" gap={1}>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            اجمالي السعر: {user.total_price}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            اجمالي الضريبة: {user.tax_total}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            اجمالي الخصم: {user.total_discount}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            الاجمالي المطلوب: {user.total}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            تاريخ الطلب: {formatDateTime(user.created_at)}
          </MDTypography>
        </MDBox>
      ),
      customer_details: (
        <MDBox display="flex" flexDirection="column" gap={1}>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            الاسم : {user.customer_addresse?.name}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            العنوان : {user.customer_addresse?.address}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            الهاتف : {user.customer_addresse?.phone}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            المنطقة :{" "}
            {user.customer_addresse?.location_hierarchy?.country?.name +
              " - " +
              user.customer_addresse?.location_hierarchy?.province?.name +
              " - " +
              user.customer_addresse?.location_hierarchy?.state?.name}
          </MDTypography>
        </MDBox>
      ),
      payment_details: (
        <MDBox display="flex" flexDirection="column" gap={1}>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            طريقة الدفع: {user.payment_method?.name}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            طريقة الشحن: {user.shipping_method?.name}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium">
            العملة: {user.currency?.name}
          </MDTypography>
        </MDBox>
      ),
      products_status: (
        <MDBox display="flex" flexDirection="column" gap={1}>
          <Select
            value={status || user.status}
            onChange={(e) => handleStatusChange(user, e.target.value)}
            size="small"
            IconComponent={KeyboardArrowDownIcon}
            variant="outlined"
            input={<OutlinedInput notched={false} label="" />}
            sx={{
              minWidth: 120,
              fontWeight: "bold",
              color: "#FFA726",
              borderRadius: 2,
              backgroundColor: "#fff",
              boxShadow: 1,
              border: "1px solid #FFA726",
              height: 38,
              ".MuiSelect-icon": { color: "#222", fontSize: 28 },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
            }}
            displayEmpty
            disabled={loadingOrderId === user.id}
            endAdornment={
              loadingOrderId === user.id ? <CircularProgress size={20} sx={{ ml: 1 }} /> : null
            }
          >
            <MenuItem value={user.status} disabled>
              {statusOptions.find((o) => o.value === user.status)?.label || user.status}
            </MenuItem>
            {statusOptions
              .filter((option) => option.value !== user.status)
              .map((option, idx) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  sx={{
                    backgroundColor: option.color,
                    color: "#fff",
                    fontWeight: "bold",
                    mb: idx !== statusOptions.length - 1 ? 1 : 0,
                    "&.Mui-selected": {
                      backgroundColor: option.color + " !important",
                      color: "#fff",
                    },
                    "&:hover": {
                      backgroundColor: option.color,
                      opacity: 0.9,
                    },
                    borderRadius: 1,
                    px: 2,
                  }}
                >
                  {option.label}
                </MenuItem>
              ))}
          </Select>
        </MDBox>
      ),
      order_action: (
        <Button
          variant="contained"
          color="info"
          size="small"
          startIcon={<InfoIcon />}
          sx={{
            borderRadius: 2,
            fontWeight: "bold",
            boxShadow: 1,
            textTransform: "none",
            px: 2,
            py: 0.5,
            fontSize: 15,
          }}
          onClick={() => handleOrderDetailsClick(user)}
        >
          تفاصيل الطلب
        </Button>
      ),
      order_preview: (
        <IconButton
          color="info"
          component="a"
          href={`/order-preview/${user.id}`}
          target="_blank"
          sx={{ borderRadius: 2 }}
        >
          <VisibilityIcon />
        </IconButton>
      ),
    })),
  };
}
